import { makeStyles, Theme } from '@material-ui/core';

export const useTreasuryStyles = makeStyles<Theme>((theme) => ({
  wrapper: {
    display: 'grid',
    padding: '0 60px',

    [theme.breakpoints.down('sm')]: {
      padding: '0 10px',
    },
  },
  pageTitleWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    maxWidth: 1216,
    width: '100%',
    margin: 'auto',
    padding: '32px 0px 0',
    [theme.breakpoints.down('sm')]: {
      padding: '24px 16px',
    },
  },
  pageTitle: {
    color: '#FAFAFA',
    fontSize: '24px',
    fontWeight: 400,
    lineHeight: '32px',
    [theme.breakpoints.down(390)]: {
      display: 'none',
    },
  },
  pageTitleButtons: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
  },
  pageTitleButton: {
    color: '#FAFAFA',
    textAlign: 'center',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    borderRadius: '56px',
    padding: '8px 24px',
    background: '#1E1E20',
    transition: 'all 0.1s ease',
    cursor: 'pointer',
    whiteSpace: 'nowrap',

    '&:hover': {
      background: '#2d2d2f',
    },
  },
  pageTitleButtonActive: {
    background: '#7F53FE',

    '&:hover': {
      background: '#7F53FE',
    },
  },
  root: {
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: '#121212',
  },
  addressBookDialogName: {
    '& > div': { color: '#fafafa' },
  },
  test: {
    position: 'fixed',
    top: '48px',
    left: '0',
    right: '0',
    margin: '0 auto',
    display: 'flex',
    maxWidth: '595px',
    padding: '16px 24px',
    alignItems: 'center',
    borderRadius: '12px',
    border: '1px solid #323235',
    background: '#292A2F',
    zIndex: 999,
    boxShadow: '0 4px 24px 0 rgba(0, 0, 0, 0.40)',
    justifyContent: 'space-between',
    minWidth: '600px',
    [theme.breakpoints.down('xs')]: {
      maxWidth: '354px',
      padding: '16px 16px',
    },
    '& .left': {
      display: 'flex',
      alignItems: 'center',
    },
    '& .accept': {
      display: 'flex',
      width: '79.5px',
      height: '48px',
      padding: '13px 16px',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '10px',
      fontSize: '14px',
      flexShrink: 0,
      borderRadius: '6px',
      background: 'rgba(255, 255, 255, 0.10)',
      cursor: 'pointer',
      '&:hover': {
        background: 'rgba(255, 255, 255, 0.15)',
      },
    },
    '& div.icon-wrap': {
      width: '40px',
      height: '40px',
      background: '#5ED1B0',
      borderRadius: '24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: '16px',
      '&.rejected': {
        background: '#E44E45',
      },
    },
    '& .title': {
      color: '#fafafa',
      fontSize: '16px',
      fontWeight: 700,
      lineHeight: '32px',
    },
    '& .subtitle': {
      color: '#949494',
      fontSize: '13px',
      fontWeight: 500,
      lineHeight: '20px',
      whiteSpace: 'pre-line',
    },
  },
  content: {
    width: '100%',
    padding: '24px 0px 8px',
    maxWidth: '1216px',
    [theme.breakpoints.down('sm')]: {
      padding: '24px 16px',
    },
  },
  safeList: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '32px',
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      width: 592,
      gap: '16px',
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  safeItemLoading: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    '& > img': {
      width: '56px',
      marginTop: '19px',
    },
    '& > h5': {
      marginTop: '8px',
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: '20px',
      color: '#ABABAB',
    },
    '& > span': {
      marginTop: '16px',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '18px',
      color: '#FAFAFA',
      textDecoration: 'underline',
    },
  },

  safeItem: {
    height: '204px',
    width: '280px',
    padding: '24px',
    background: '#1F2023',
    border: 'none',
    borderRadius: '12px',
    display: 'grid',
    gridTemplateRows: 'min-content 1fr',
    cursor: 'pointer',
    // position: "relative",
    outline: '0px solid rgba(255,255,255,0.1)',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      minHeight: '180px',
      minWidth: '100%',
    },
    '&:hover': {
      outline: '2px solid rgba(255,255,255,0.3)',
      transform: 'scale(1.01)',
      transition: 'all linear 0.1s',
    },
  },

  safeInviteAvatarWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '3px solid #1F2023',
    width: 43,
    height: 43,
    background: '#424245',
    borderRadius: '50%',

    '&>*': {
      width: 43,
      height: 43,
      borderRadius: '50%',
    },
  },

  safeAvatarWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 43,
    height: 43,
    background: '#2C2C30',
    borderRadius: '50%',

    '&>*': {
      width: 43,
      height: 43,
      borderRadius: '50%',
    },
  },

  safeItemTop: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'flex-start',
    },
  },
  safeItemHeader: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    display: 'grid',
  },

  safeItemHeaderWalletAddress: {
    display: 'flex',
    gap: 8,
    cursor: 'pointer',
    color: '#949494',
  },
  safeItemHeaderTitle: {
    color: '#FAFAFA',
    fontSize: '16px',
    fontFamily: 'Open Sauce One, sans-serif',
    fontWeight: 500,
    lineHeight: '24px',
    display: 'flex',
    gap: '4px',
  },
  safeSeparator: {
    width: '100%',
    height: 1,
    background: '#323335',
    margin: '24px auto',
  },
  safeItemBottom: {
    height: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0px 8px',
    gap: 8,
  },
  safeItemOwners: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 'auto',
    width: 'min-content',
    justifyContent: 'center',
  },
  safeItemOwnersWrapper: {
    display: 'flex',
    paddingLeft: 8,
    margin: '0 auto',
  },
  safeItemOwnersCounter: {
    display: 'flex',
    gap: '6px',
    margin: '10px auto 0',
  },
  safeItemOwnersCounterNumber: {
    fontFamily: 'Open Sauce One, sans-serif',
    fontSize: 14,
    fontWeight: 500,
    color: '#FAFAFA',
  },
  safeItemOwnersCounterText: {
    fontFamily: 'Open Sauce One, sans-serif',
    color: '#949494',
    fontSize: 14,
    fontWeight: 500,
  },

  inviteSafeTop: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderBottom: '1px solid #FFFFFF1A',
    paddingBottom: '8px',
  },
  inviteJoined: {
    display: 'grid',
    gridTemplateColumns: '50% 50%',
    justifyContent: 'center',
    alignContent: 'center',
    marginTop: '8px',
    gap: '15px',
    width: '100%',
  },
  inviteJoinedItem: {
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    padding: '8px 0px',
    color: '#ABABAB',
    fontSize: '12px',
    // fontFamily: "Inter, sans-serif",
    fontWeight: 500,
    lineHeight: '16px',
  },
  inviteCode: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginTop: '20px',
    gap: '8px',
  },
  invitationCode: {
    color: '#ABABAB',
    fontSize: '12px',
    fontWight: '500',
    lineHeight: ' 16px',
  },
  copyCode: {
    display: 'flex',
    alignItems: 'center',
    padding: '5px 15px',
    height: '34px',
    gap: '8px',
    background: 'rgba(255, 255, 255, 0.1)',
    borderRadius: '22px',
  },
  inviteWaiting: {
    display: 'flex',
    height: '50px',
    position: 'relative',
    justifyContent: 'flex-end',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  icon: {
    position: 'absolute',
    left: '2px',
    top: '2px',
    zIndex: 10,
    [theme.breakpoints.down('sm')]: {},
  },
  inviteHeadWrapper: {
    display: 'grid',
    background: 'rgba(105, 111, 255, 0.15)',
    width: '100%',
    height: '48px',
    borderRadius: '22px 8px 8px 22px',
    justifyContent: 'start',
  },
  inviteSafeTitle: {
    fontWeight: 500,
    fontSize: 16,
    paddingLeft: 56,
    textAlign: 'left',
  },
  inviteHead: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    paddingLeft: 50,
  },
  ownerAvatar: {
    color: 'white',
    width: '24px',
    height: '24px',
    fontSize: '12px',
    border: '2px solid #202024',
    marginLeft: -8,
  },
  ownerAddAvatar: {
    minWidth: '24px',
    width: 'unset',
    color: 'white',
    height: '24px',
    fontSize: '12px',
    border: '2px solid #202024',
    marginLeft: -8,
    borderRadius: '12px',
    padding: '0 4px',
  },
  safeCreatedTime: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    justifyContent: 'space-between',
    '& > span': {
      display: 'flex',
      alignContent: 'center',
      justifyContent: 'center',
      color: 'var(--dark-neutral-base, #FAFAFA)',
      fontSize: '14px',
    },
  },
  creationDate: {
    fontFamily: 'Open Sauce One, sans-serif',
    color: '#949494',
    fontSize: 14,
    fontWeight: 500,
  },

  safeAddWrap: {
    flex: '0 1 calc((100% - 96px) / 4)',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    [theme.breakpoints.down('xs')]: {
      flex: '1',
      width: '100%',
      height: '56px',
      flexDirection: 'row',
    },
  },
  safeAdd: {
    height: '94px',
    minWidth: '280px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#FFFFFF',
    borderRadius: '12px',
    border: '1px dashed #3D3D44',
    background: '#1B1C1E',
    cursor: 'pointer',
    [theme.breakpoints.down('xs')]: {
      width: '50%',
      height: '56px',
      minWidth: 'unset',
    },

    '&>img': {
      paddingRight: '8px',
    },
    '&>h4': {
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: '20px',
      [theme.breakpoints.down('xs')]: {
        fontSize: '13px',
      },
    },
    '&:hover': {
      // transform: "translateY(-4px)",
      // transition: "transform .2s ease-in-out, box-shadow .2s ease-in-out",
      background: '#292A2F',
    },
  },
  contentEmpty: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '150px',
    '& > h2': {
      fontWeight: 400,
      fontSize: '24px',
      lineHeight: '20px',
      color: '#FAFAFA',
      margin: '24px 0 20px',
    },
    '& > span': {
      fontWeight: 600,
      fontSize: '14px',
      lineHeight: '18px',
      color: '#B0B3BF',
      marginBottom: '24px',
      maxWidth: '384px',
      textAlign: 'center',
    },
    '& > div': {
      display: 'flex',
      flexDirection: 'row',
    },
  },
}));
